import React from 'react';
import Head from 'next/head';
import { CityDirectoryData } from 'types/app';
import { CityArticleList } from './components/CityArticleList';
import { NeighborhoodList } from './components/NeighborhoodList';
import { Box } from '../../components/Box';
import { Container } from '../../components/Container';
import { Flex } from '../../components/Flex';
import { Layout } from '../../components/Layout';
import { Typography } from '../../components/Typography';
import { useCanonicalUrl } from '../../hooks';
import { WAG_GATSBY_URL, URL_STATE_DIRECTORY } from '../../constants';
import backgroundDesktop from './assets/background-desktop.png';
import { Span } from '../../wag-react/core-components/span';
import { Image } from '../../wag-react/core-components/image';
import { Breadcrumbs } from '../../wag-react/components/Breadcrumbs';
type Props = {
  data: CityDirectoryData;
};
export const CityDirectory = ({
  data: {
    state,
    stateAbbrev,
    city,
    cityArticles,
    neighborhoods
  }
}: Props) => {
  const {
    canonicalUrl
  } = useCanonicalUrl();
  return <>
      <Head data-sentry-element="Head" data-sentry-source-file="CityDirectory.tsx">
        <title>{`Dog Services in ${city}, ${state} | Wag!`}</title>
        <meta name="description" content={`Check out local dog services available in ${city}, ${state}. Browse top dog services like dog walking, sitting and boarding, training and more!`} data-sentry-element="meta" data-sentry-source-file="CityDirectory.tsx" />
        <meta name="robots" content="noindex, nofollow" data-sentry-element="meta" data-sentry-source-file="CityDirectory.tsx" />
        <link href={canonicalUrl} rel="canonical" />
      </Head>
      <Layout data-sentry-element="Layout" data-sentry-source-file="CityDirectory.tsx">
        <Flex position="relative" alignItems="center" height={['136px', '272px', '500px', 'max(35vw, 700px)']} data-sentry-element="Flex" data-sentry-source-file="CityDirectory.tsx">
          <Image src={backgroundDesktop} height="100%" width={1} alt="city-directory-background" data-sentry-element="Image" data-sentry-source-file="CityDirectory.tsx" />
          <Box position="absolute" zIndex={1} data-sentry-element="Box" data-sentry-source-file="CityDirectory.tsx">
            <Container data-sentry-element="Container" data-sentry-source-file="CityDirectory.tsx">
              <Typography variant="h1" color="white" mt={0} data-sentry-element="Typography" data-sentry-source-file="CityDirectory.tsx">
                Dog services in&nbsp;
                <Span display="block" data-sentry-element="Span" data-sentry-source-file="CityDirectory.tsx">
                  {city}
                </Span>
              </Typography>
            </Container>
          </Box>
        </Flex>
        <Container data-sentry-element="Container" data-sentry-source-file="CityDirectory.tsx">
          <Breadcrumbs variant="ul" list={[{
          title: 'Wag!',
          url: WAG_GATSBY_URL
        }, {
          title: state,
          url: URL_STATE_DIRECTORY({
            state: stateAbbrev.toLowerCase()
          })
        }, {
          title: city
        }]} data-sentry-element="Breadcrumbs" data-sentry-source-file="CityDirectory.tsx" />
          <Box pt={[1, 0]} pb={[3, 5]} data-sentry-element="Box" data-sentry-source-file="CityDirectory.tsx">
            <Typography variant="h2" textAlign={['left', 'center']} data-sentry-element="Typography" data-sentry-source-file="CityDirectory.tsx">
              {`Top dog services in ${city}`}
            </Typography>
            <CityArticleList articles={cityArticles} data-sentry-element="CityArticleList" data-sentry-source-file="CityDirectory.tsx" />
          </Box>
          {neighborhoods.length > 0 && <>
              <hr />
              <Box pb={5}>
                <Typography variant="h2" textAlign={['left', 'center']}>
                  Wag! services in your neighborhood
                </Typography>
                <NeighborhoodList neighborhoods={neighborhoods} />
              </Box>
            </>}
        </Container>
      </Layout>
    </>;
};